import { takeLatest, put, call, select } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { REMOVE_SLIDE, REMOVE_SLIDE_FAIL, REMOVE_SLIDE_SUCCESS, RemoveSlideAction } from '../redux/manageSlidesReducer'
import { RootReducer } from '../redux/rootReducer'
import { FETCH_SLIDES } from '../redux/manageSlidesReducer'
function* RemoveSlideFlow(action: RemoveSlideAction): Generator<any, void, any> {
  try {
    const slideId = yield select((state: RootReducer) => state.manageSlidesReducer.activeSlide?.id)
    yield call(apiCall, {
      endpoint: `/tutors/slides/${slideId}`,
      method: 'DELETE',
      params: {}
    })
    yield put(REMOVE_SLIDE_SUCCESS())
    yield put(FETCH_SLIDES({ lessonPlanId: action.payload.lessonPlanId }))
  } catch (error) {
    yield put(REMOVE_SLIDE_FAIL())
    console.log(error)
  }
}

export default function* RemoveSlideSaga(): Generator<any, void, any> {
  yield takeLatest([REMOVE_SLIDE], RemoveSlideFlow)
}
